import { render, staticRenderFns } from "./PrimaryBodyPart.vue?vue&type=template&id=5d274d40&scoped=true"
import script from "./PrimaryBodyPart.vue?vue&type=script&lang=js"
export * from "./PrimaryBodyPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d274d40",
  null
  
)

export default component.exports